import { render, staticRenderFns } from "./ClassLogin.vue?vue&type=template&id=5d4c2828&scoped=true&"
import script from "./classlogin.js?vue&type=script&lang=js&"
export * from "./classlogin.js?vue&type=script&lang=js&"
import style0 from "./ClassLogin.vue?vue&type=style&index=0&id=5d4c2828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4c2828",
  null
  
)

export default component.exports